import { ReactEnvironments } from "./pages/common/constants";
import { FUNCTIONAL_AREA_SEARCH_URL_MAP } from "./pages/LandingPage/constants";
import { HarnessObjectType } from "./types";

export const CDCM_UI = {
  LOCAL_URL: "http://localhost:3000/",
  DEV_URL: "https://app-cdcm-ui.app-dev.connectcdk.com",
  DIT_URL: "https://app-cdcm-ui.app-dit.connectcdk.com",
  STAGE_URL: "https://app-cdcm-ui.app-stage.connectcdk.com",
  PERF_URL: "https://app-cdcm-ui.app-perf.connectcdk.com",
  PROD_URL: "https://app-cdcm-ui.app.connectcdk.com",
};

export const CDCM_API = {
  LOCAL_URL: "http://localhost:8083/",
  DEV_URL: "https://bff-cdcm-api.ext.nebula-dev.connectcdk.com/",
  DIT_URL: "https://bff-cdcm-api.ext.nebula-dit.connectcdk.com/",
  STAGE_URL: "https://bff-cdcm-api.ext.nebula-stage.connectcdk.com/",
  PERF_URL: "https://bff-cdcm-api.ext.nebula-perf.connectcdk.com/",
  PROD_URL: "https://bff-cdcm-api.ext.nebula.connectcdk.com/",
};

export const COMMON_ADMIN = {
  DEV_URL: "https://admin-dev.connectcdk.com/",
  DIT_URL: "https://www-dit.connectcdk.com/a/cadmin/",
  STAGE_URL: "https://admin-stage.connectcdk.com/",
  PROD_URL: "https://www.connectcdk.com/a/cadmin/",
};

export const MODSET = {
  DEV_URL: "https://dms-setups-{functionalArea}-read-jwt.na-dev.connectcdk.com",
  STAGE_URL:
    "https://dms-setups-{functionalArea}-read-jwt.na-stage.connectcdk.com",
  PERF_URL:
    "https://dms-setups-{functionalArea}-read-jwt.na-perf.connectcdk.com",
  PROD_URL: "https://api.connectcdk.com/",
};

export const ME = {
  DIT_URL: "https://identity.global-dit.connectcdk.com/",
  PERF: "https://svc-identity-service-perf-istio.ext.nebula-perf.connectcdk.com/",
  PROD_URL: "https://identity.global.connectcdk.com/",
};

export const DETAILS = {
  DEV_URL: "https://dms-ui-common-bff-jwt.na-dev.connectcdk.com/",
  PERF_URL: "https://dms-ui-common-bff-jwt.na-perf.connectcdk.com/",
  STAGE_URL: "https://dms-ui-common-bff-jwt.na-stage.connectcdk.com/",
  PROD_URL: "https://dms-ui-common-bff-jwt.na.connectcdk.com/",
};

export const PURCHASE_ORDER_DETAILS = {
  DEV_URL:
    "https://bff-dms-accounting-purchase-order-bff.na-dev.connectcdk.com/",
  PERF_URL:
    "https://bff-dms-accounting-purchase-order-bff.na-perf.connectcdk.com",
  STAGE_URL:
    "https://bff-dms-accounting-purchase-order-bff.na-stage.connectcdk.com/",
  PROD_URL: "https://bff-dms-accounting-purchase-order-bff.na.connectcdk.com",
};

export const RACE = {
  DIT_URL: "https://race-dit.connectcdk.com/#/dashboard",
  QA_URL: "https://race-qa.connectcdk.com/#/dashboard",
  PROD_URL: "https://race.connectcdk.com/#/dashboard",
};

export const DWM = {
  DEV_URL: "https://app-dms-root-app.app-dev.connectcdk.com",
  STAGE_URL: "https://app-dms-root-app.app-stage.connectcdk.com",
  PROD_URL: "https://driveworkflowmenu.connectcdk.com",
};

export const OKTA_PREVIEW_SESSION = {
  PROD_URL: "https://connectcdk.okta.com/",
  DIT_URL: "https://connectcdk-dit.oktapreview.com/",
};

export const OKTA_SSO_SESSION = {
  PROD_URL: "https://sso.connectcdk.com/",
  DIT_URL: "https://sso-dit.connectcdk.com/",
};

export const HARNESS_KEYS = {
  PROD: "a9e45cb0-3a6d-48de-a8be-0cf82e2e2e73",
  DIT: "b7ebbdbe-64f3-4ec9-92e0-a2e7a5f846d5",
  STAGE: "2f6fb06d-112b-4578-9c80-e5e44f28204a",
  DEVELOP: "a8753bc8-7db8-4297-bfbf-1e16fa43123d",
};

export const HARNESS_TARGETS = {
  PROD: "ProdCDCMUISDKKey",
  DIT: "DITSDKKeyForCDCMUI",
  STAGE: "StageCDCMUISDKKey",
  DEVELOP: "DevSDKKeyForCDCMUI",
};

export const getENV = (origin: string = window.location.origin): string => {
  if (origin.includes(ReactEnvironments.Staging)) {
    return ReactEnvironments.Staging;
  } else if (origin.includes(ReactEnvironments.Perf)) {
    return ReactEnvironments.Perf;
  } else if (origin.includes(ReactEnvironments.Develop)) {
    return ReactEnvironments.Develop;
  } else if (origin.includes(ReactEnvironments.DIT)) {
    return ReactEnvironments.DIT;
  } else if (origin.includes(ReactEnvironments.Local)) {
    return ReactEnvironments.Local; // CHANGE TO SIMULATE DIFFERENT ENV
  } else {
    // This might be questionable lol
    console.warn("Environment not found, using default", origin);
    return ReactEnvironments.Production;
  }
};

// This whole function seems unnecessary we can just use window.location.origin
export const getUIHostUrl = (
  origin: string = window.location.origin,
): string => {
  if (origin.includes(ReactEnvironments.Staging)) {
    return CDCM_UI.STAGE_URL;
  } else if (origin.includes(ReactEnvironments.Perf)) {
    return CDCM_UI.PERF_URL;
  } else if (origin.includes(ReactEnvironments.Develop)) {
    return CDCM_UI.DEV_URL;
  } else if (origin.includes(ReactEnvironments.DIT)) {
    return CDCM_UI.DIT_URL;
  } else if (origin.includes(ReactEnvironments.Local)) {
    return CDCM_UI.LOCAL_URL;
  } else {
    console.warn("UI host url not found, using default", origin);
    return CDCM_UI.PROD_URL;
  }
};

export const getAPIBffBase = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return CDCM_API.PROD_URL;
    case ReactEnvironments.Staging:
      return CDCM_API.STAGE_URL;
    case ReactEnvironments.Perf:
      return CDCM_API.PERF_URL;
    case ReactEnvironments.Develop:
      return CDCM_API.DEV_URL;
    case ReactEnvironments.DIT:
      return CDCM_API.DIT_URL;
    case ReactEnvironments.Local:
      return CDCM_API.LOCAL_URL;
    default:
      console.warn("BFF base url not found, using default", env);
      return CDCM_API.DEV_URL;
  }
};

export const getMeApiUrl = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return ME.PROD_URL;
    case ReactEnvironments.Develop:
    case ReactEnvironments.DIT:
    case ReactEnvironments.Staging:
      return ME.DIT_URL;
    case ReactEnvironments.Perf:
      return ME.PERF;
    default:
      console.warn("Me base url not found, using default", env);
      return ME.DIT_URL;
  }
};

export const getDetailsApiUrl = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return DETAILS.PROD_URL;
    case ReactEnvironments.Staging:
      return DETAILS.STAGE_URL;
    case ReactEnvironments.Perf:
      return DETAILS.PERF_URL;
    case ReactEnvironments.DIT:
    case ReactEnvironments.Develop:
      return DETAILS.DEV_URL;
    default:
      console.warn("Me base url not found, using default", env);
      return DETAILS.DEV_URL;
  }
};

export const getPurchaseOrderDetailsApiUrl = (
  env: string = getENV(),
): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return PURCHASE_ORDER_DETAILS.PROD_URL;
    case ReactEnvironments.Staging:
      return PURCHASE_ORDER_DETAILS.STAGE_URL;
    case ReactEnvironments.Perf:
      return PURCHASE_ORDER_DETAILS.PERF_URL;
    case ReactEnvironments.DIT:
    case ReactEnvironments.Develop:
      return PURCHASE_ORDER_DETAILS.DEV_URL;
    default:
      console.warn("Me base url not found, using default", env);
      return PURCHASE_ORDER_DETAILS.DEV_URL;
  }
};

export const getRaceBase = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return RACE.PROD_URL;
    case ReactEnvironments.Staging:
    case ReactEnvironments.Perf:
      return RACE.QA_URL;
    case ReactEnvironments.Develop:
    case ReactEnvironments.DIT:
      return RACE.DIT_URL;
    default:
      console.warn("Race base url not found, using default", env);
      return RACE.DIT_URL;
  }
};

export const getCommonAdminBase = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return COMMON_ADMIN.PROD_URL;
    case ReactEnvironments.Staging:
      return COMMON_ADMIN.STAGE_URL;
    case ReactEnvironments.DIT:
    case ReactEnvironments.Perf:
      return COMMON_ADMIN.DIT_URL;
    case ReactEnvironments.Develop:
      return COMMON_ADMIN.DEV_URL;
    case ReactEnvironments.Local:
      return COMMON_ADMIN.DEV_URL;
    default:
      return COMMON_ADMIN.DEV_URL;
  }
};

export const getModsetBase = (
  functionalArea: string,
  requestUrl: string,
): string => {
  const effectiveFunctionalArea =
    FUNCTIONAL_AREA_SEARCH_URL_MAP.get(requestUrl) ?? functionalArea;

  const env: string = getENV();

  const modsetUrls: Record<string, string> = {
    [ReactEnvironments.Production]: MODSET.PROD_URL,
    [ReactEnvironments.Staging]: MODSET.STAGE_URL,
    [ReactEnvironments.Perf]: MODSET.PERF_URL,
    [ReactEnvironments.Develop]: MODSET.DEV_URL,
    [ReactEnvironments.DIT]: MODSET.STAGE_URL,
  };

  const url = modsetUrls[env] || MODSET.DEV_URL;

  if (!modsetUrls[env]) {
    console.warn("Modset base url not found, using default", env);
  }

  return url.replace("{functionalArea}", effectiveFunctionalArea || "");
};

export const getOktaPreviewSessionUrl = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return OKTA_PREVIEW_SESSION.PROD_URL;
    case ReactEnvironments.Local:
    case ReactEnvironments.Staging:
    case ReactEnvironments.Perf:
    case ReactEnvironments.Develop:
    case ReactEnvironments.DIT:
      return OKTA_PREVIEW_SESSION.DIT_URL;
    default:
      console.warn("Okta base url not found, using default", env);
      return OKTA_PREVIEW_SESSION.DIT_URL;
  }
};

export const getOktaSessionUrl = (env: string = getENV()): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return OKTA_SSO_SESSION.PROD_URL;
    case ReactEnvironments.Local:
    case ReactEnvironments.Staging:
    case ReactEnvironments.Perf:
    case ReactEnvironments.Develop:
    case ReactEnvironments.DIT:
      return OKTA_SSO_SESSION.DIT_URL;
    default:
      console.warn("Vanity base url not found, using default", env);
      return OKTA_SSO_SESSION.DIT_URL;
  }
};

export const getHarnessFlag = (env: string = getENV()): HarnessObjectType => {
  switch (env) {
    case ReactEnvironments.Production:
      return {
        apiKey: HARNESS_KEYS.PROD,
        target: {
          identifier: HARNESS_TARGETS.PROD,
        },
      };
    case ReactEnvironments.Local:
    case ReactEnvironments.Develop:
      return {
        apiKey: HARNESS_KEYS.DEVELOP,
        target: {
          identifier: HARNESS_TARGETS.DEVELOP,
        },
      };
    case ReactEnvironments.DIT:
      return {
        apiKey: HARNESS_KEYS.DIT,
        target: {
          identifier: HARNESS_TARGETS.DIT,
        },
      };
    case ReactEnvironments.Staging:
      return {
        apiKey: HARNESS_KEYS.STAGE,
        target: {
          identifier: HARNESS_TARGETS.STAGE,
        },
      };
    default:
      console.warn("Harness key & target not found, using default", env);
      return {
        apiKey: HARNESS_KEYS.DEVELOP,
        target: {
          identifier: HARNESS_TARGETS.DEVELOP,
        },
      };
  }
};


